import { Gender, type SubmitBuyerPassenger } from '@store/form';
import BillHandler from '@itinerary/BillHandler';
import { PaxType } from '@utils/types';
import { BillsApiApiBillsBillCodeBeginPaymentGet } from '@clients/BillApi';
import { ReserveApiApiReserveCreateFlightBillPost } from '@clients/FlightApi';
import { type InvoiceEntry } from '@store/invoice';
import { ReserveType } from '@utils/itinerary';

export default class FlightBillHandler extends BillHandler {
    override concreteType = ReserveType.Flight;

    private token: string;

    private optionalServiceTokens: string[];

    constructor(token: string, optionalServiceTokens: string[]) {
        super();
        this.token = token;
        this.optionalServiceTokens = optionalServiceTokens;
    }

    override async registerPaxInfo(params: {
        pax: SubmitBuyerPassenger[];
        email: string;
        mobile: string;
        billId: number;
        customData: any;
        billCode: string;
        bypassPaxCountValidation?: boolean;
        entries: InvoiceEntry[];
        message?: string;
    }): Promise<{
        result: boolean;
        departureTime: Date | null;
        data?: any;
    }> {
        await ReserveApiApiReserveCreateFlightBillPost({
            registerReserveInfoRequest: {
                Person: params.pax.map(p => ({
                    FirstName: p.firstName,
                    LastName: p.lastName,
                    PersianFirstName: p.persianFirstName,
                    PersianLastName: p.persianLastName,
                    Male: p.gender === Gender.Male,
                    NationalCode: p.nationalCode,
                    BirthDay: p.birthDate,
                    PassportExpiration: p.passportExpiry,
                    PassportNumber: p.passportNumber,
                    PaxType:
                        p.type === PaxType.Adult
                            ? 'ADL'
                            : p.type === PaxType.Child
                              ? 'CHD'
                              : 'INF',
                    Nationality: p.nationalityCode,
                    PerPassengerAuxiliaryServices: p.packageOptionalService
                        .filter(
                            s =>
                                s.service &&
                                this.optionalServiceTokens.includes(
                                    s.service.id
                                )
                        )
                        .map(s => s.service!.id),
                })),
                Bill: {
                    Id: params.billId,
                    Email: params.email,
                    Mobile: params.mobile,
                    SecondaryMobile: params.mobile,
                },
                ByPassPaxCountValidation: !!params.bypassPaxCountValidation,
                Message: params.message,
                Token: this.token,
            },
        });
        return {
            result: true,
            departureTime: null,
        };
    }

    override getTitle(type: PaxType, gender: Gender): string {
        switch (type) {
            case PaxType.Adult:
                return gender === Gender.Male ? 'MR' : 'MRS';
            case PaxType.Child:
                return 'CHD';
            case PaxType.Infant:
                return 'INF';
        }

        return '';
    }

    override async prepayReservation(billCode: string): Promise<void> {
        await BillsApiApiBillsBillCodeBeginPaymentGet({ billCode });
    }
}
